module.exports = __webpack_public_path__ + "static/after4-62ba4bac6150c58c891be9bbd4964af7.jpg";